export default __webpack_public_path__ + "static/media/logo.28848406.png";